export const templates = {
  purchase: {
    name: "Purchasing template.csv",
    link: `/files/Purchasing template.csv`,
  },
  sales: {
    name: "Sales template.csv",
    link: `/files/Sales template.csv`,
  }
}